import { showNotification } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";

import { authPost } from "@shared/api";
import { ApiError, OrgData } from "@shared/types";
import { queryClient } from "@shared/utils";

const joinDeployment = async (deploymentId: number): Promise<OrgData> => {
  return authPost<Record<string, never>, { deployment: OrgData }>(
    `/api/agent/deployments/${deploymentId}/users`,
    {}
  ).then((response) => {
    return response.deployment;
  });
};

export const useJoinDeploymentMutation = () => {
  return useMutation({
    mutationFn: (deploymentId: number) => joinDeployment(deploymentId),
    onError: (err: ApiError) => {
      showNotification({
        message:
          err.message ||
          "There was an issue joining an organization with the provided name.",
      });
    },
    onSuccess: () => {
      // NOTE: Coupling with the `useUserOrgs` hook, we invalidate the current user's orgs
      queryClient.invalidateQueries({ queryKey: ["userDeployments"] });
      queryClient.invalidateQueries({ queryKey: ["userJoinableDeployments"] });
    },
  });
};
